/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/order";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/order";
/// TYPES ///
import { Order } from "api/types/order/order";
/// LODASH ///
import { orderBy } from "lodash";
/// SORT VALUES ///
import { NAME } from "values/sort/order";
import { CUSTOMER } from "values/sort/order";
import { DATE } from "values/sort/order";
import { TOTAL } from "values/sort/order";
import { NUMBER } from "values/sort/order";

function sort(os: Order[], sort_type: number, sort_up: boolean): Order[] {
  let sort_field: string = "name";

  switch (sort_type) {
    case NAME:
      sort_field = "name";
      break;
    case CUSTOMER:
      sort_field = "end_customer_data.last_name";
      break;
    case DATE:
      sort_field = "end_customer_data.email";
      break;
    case TOTAL:
      sort_field = "total";
      break;
    case NUMBER:
      sort_field = "order_number";
      break;
    default:
      sort_field = "name";

  };

  return orderBy(os, sort_field, sort_up ? "asc" : "desc");
}

export const sortMarketOrders = (sort_type: number, sort_up: boolean) => {
  return async (dispatch: Dispatch<Action>, getState: () => RootState) => {
    const { orders } = getState().order;

    dispatch({
      type: ActionType.SORT_MARKET_ORDER,
      orders: sort(orders, sort_type, sort_up)
    });
  }
}

